// react to chat message/s state
// documentation link tbc

const state = {

};

const getters = {

};

const mutations = {

};

const actions = {
  //delete chat message/s functionality
  async reactToChatMessageHandler({dispatch}, data) {
    let res = await dispatch('api/chat/toggleMessageReactions',data)
    dispatch('reactToChatMessageCallback', res)
    return res
  },
  async reactToChatMessageCallback({dispatch}, res) {
    if(!res.success) {
      //show error
      dispatch('popups/show/error/custom', 'reacting to this message')
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
